module.exports = __webpack_public_path__ + "img/logout-reverse.dfc3c60c.svg";